import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { CertPeriodRecapQuestionnaireItem } from './questionnaire'

// TODO: Implement questionnaire item to answer type
export const CERT_PERIOD_RECAP_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CONSENT]: QuestionnaireAnswerType.REFERENCE,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_ER]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_ER_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_HOSPITAL]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_HOSPITAL_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_FALLS]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_FALLS_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_INFECTIONS]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_INFECTIONS_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_MD]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_MD_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_INJURIES]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_INJURIES_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_GOALS]: QuestionnaireAnswerType.GROUP,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_GOALS_GOAL_ID]:
    QuestionnaireAnswerType.INTEGER,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_GOALS_GOAL_STATUS]:
    QuestionnaireAnswerType.STRING,
  [CertPeriodRecapQuestionnaireItem.CERT_PERIOD_RECAP_INITIALS_AUTHORIZATION]:
    QuestionnaireAnswerType.STRING
}
